// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const light = "rgba(48, 49, 51, 0.1)"; // shadow 1
const mid = "rgba(13, 10, 44, 0.06)"; // shadow 3
const dark = "rgba(0, 0, 0, 0.10)"; // shadow 2

const shadows: Styleguide["shadows"] = {
    light20: `0 1px 3px 0 ${light}`,
    mid20: `0 4px 12px 0 ${mid}`,
    dark20: `0 5px 12px 0 ${dark}`,
};

export default shadows;
